<!-- =========================================================================================
    File Name: TableContratti.vue
    Description: Table show on Contratti
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: · | ·· | ·
    Author URL: http://www.themeforest.net/user/pixinvent
    guowqujzw3v8847b0zu1rqg7kxik0h0zco3i4y8wyy1fhfgvaomxra2z539kvanp
========================================================================================== -->


<template>
  <div>
    <search-bar @find="cercaDocumento" :p="{current:this.page, tot:this.tot_page}" :filter_list="c_filters" tooltip="Creatore, Responsabile, Cliente, Tariffa, Servizio, Stato"></search-bar>
      <vs-table :key="tablekey" @next="nextPage" @prev="prevPage" :page="page" :hasNext="hasNext" :custom_pager="{current:this.page, tot:this.tot_page}" :pagination="documenti.length >= elements_per_page || page != 1" :max-items="elements_per_page" :data="documenti">
        <template slot="thead">
          <vs-th :key="i" v-for="(e, i) in ['Num.', 'Cliente', 'Emesso il', 'Servizio', 'Tariffa', 'Stato', 'Responsabile', 'Totale € (Sc.%)']">{{e}}</vs-th>
        </template>
        <template v-if="documenti.length > 0" slot-scope="{data}">
          <vs-tr class="shadow" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="[tr.numero,tr.data_emissione]" :key="0">
                {{getNumero(tr.numero,tr.data_emissione)}}
            </vs-td>

            <vs-td :data="tr.creatore" :key="1">
                {{tr.preventivo.azienda.ragione_sociale}}
            </vs-td>

            <vs-td :data="data[indextr].data" :key="2">
                {{$tariffe.formatDateNew(data[indextr].data_emissione)}}
            </vs-td>

            <vs-td :data="data[indextr].servizio" :key="3">
                {{data[indextr].preventivo.voci[0] ? data[indextr].preventivo.voci[0].tariffa_applicata.servizio.codice : ''}}
            </vs-td>

            <vs-td :data="data[indextr].tariffa" :key="4">
                {{data[indextr].preventivo.voci[0] ? data[indextr].preventivo.voci[0].tariffa_applicata.tariffa.nome : ''}}
            </vs-td>

            <vs-td :data="data[indextr].stato" :key="5">
              <vx-tooltip :text="data[indextr].stato.stato" position="left">
                <vs-button class="no-pointer-event inline-block p-1" type="flat"  icon-pack="feather" :icon="data[indextr].stato.icona"></vs-button>
              </vx-tooltip>
            </vs-td>

            <vs-td :data="tr.creatore" :key="6">
                {{[tr.responsabile.cognome,tr.responsabile.nome].join(' ')}}
            </vs-td>

            <vs-td :data="data[indextr].voci" :key="7">
              {{[new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaPreventivo(data[indextr].preventivo.voci,1,$parseCurrency(data[indextr].preventivo.importo_vecchio))),' ','( ',data[indextr].preventivo.sconto_percentuale ? new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(data[indextr].preventivo.sconto_percentuale) : 0,'%)'].join('')}}
            </vs-td>
            <template class="expand-preventivo" slot="expand" :data="tr">
              <div :key="Math.random()" class="con-expand">
                <vs-row class="sidebar-header-row p-5 mt-4" vs-justify="flex-start">
                  <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="2">Stato attuale:</vs-col>
                  <vs-col vs-w="10">
                    <ul v-if="tr.stati" class="breadcrumbs-two ">
                      <li v-for="(el, idx) in data[indextr].stati.filter(onlyUnique)" :key="idx" v-bind:class="{'current': el.stato.ordine == data[indextr].stato.ordine, 'default': el.stato.ordine <= data[indextr].stato.ordine, 'notcurrent': el.stato.ordine == 5 || el.stato.ordine == 7}">
                        <b> {{el.id_utente? el.stato.stato : el.stato.stato+' dal Cliente'}}: </b>
                        <small> {{$tariffe.formatDateNew(el.data)}} </small>
                      </li>
                    </ul>
                    <small class="bold" v-if="tr.causale_eliminato || tr.causale_rifiutato"> {{['Causale:',tr.causale_eliminato || tr.causale_rifiutato].join(' ')}} </small>
                    <small class="bold text-warning" v-if="tr.envelope_id && tr.id_stato == stati.find(e => e.ordine == 4).id">In attesa di firma</small>
                  </vs-col>
                </vs-row>

                <vs-row vs-justify="flex-end" class="m-3">
                  <vx-tooltip v-if="tr.stato.ordine < 5" text="Cambio Stato">
                    <vs-button @click="open_stato(tr)" :disabled="isDisabled(tr)" class="inline-block" radius color="success" size="small" type="line" icon-pack="feather" icon="icon-cloud-lightning"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Modifica">
                    <vs-button v-if="tr.stato.ordine <= 3" @click="handleModificaContratto(tr, $event)" class="inline-block ml-2" radius color="warning" size="small" type="line" icon-pack="feather" icon="icon-edit"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Apri preventivo">
                    <vs-button @click="openPrev(tr.id_preventivo)" class="inline-block ml-2" radius color="success" size="small" type="line" icon-pack="feather" icon="icon-clipboard"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="tr.stato.ordine != 5 && tr.stato.ordine != 7" text="Genera Contratto">
                    <vs-button @click="generatePDF(tr, $event)" class="inline-block ml-2" radius color="primary" size="small" type="line" icon-pack="feather" icon="icon-download"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="tr.stato.ordine != 5 && tr.stato.ordine != 7" text="Invia">
                    <vs-button @click="inviaDoc(tr, $event)" class="inline-block ml-2" radius color="primary" size="small" type="line" icon-pack="feather" icon="icon-mail"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="tr.stato.ordine == 4 && !tr.firma && !tr.envelope_id" text="Firma">
                  <!-- <vx-tooltip text="Firma"> -->
                    <vs-button @click="open_firma(tr)" class="inline-block ml-2" radius color="warning" size="small" type="line" icon-pack="feather" icon="icon-feather"></vs-button>
                    <!-- <vs-button @click="open_firma(tr)" :disabled="!$acl.check('responsabile') && this.utente_id != selected['id_creatore'] && this.utente_id != selected['id_responsabile']" class="inline-block ml-2" radius color="primary" size="small" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button> -->
                  </vx-tooltip>
                  <vx-tooltip v-if="tr.stato.ordine == 4" text="Carica copia cartacea">
                    <vs-button @click="open_upl(tr.id)" class="inline-block ml-2" radius color="warning" size="small" type="line" icon-pack="feather" icon="icon-paperclip"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="tr.stato.ordine == 0" text="Elimina">
                    <vs-button @click="open_delete(tr)" :disabled="isDisabled(tr)" class="inline-block ml-2" radius color="danger" size="small" type="line" icon-pack="feather" icon="icon-trash-2"></vs-button>
                  </vx-tooltip>
                </vs-row>
              </div>
            </template>
            <vs-popup :key="Math.random()" class="holamundo text-center" title="Eliminazione Contratto" :active.sync="popupDelete" button-close-hidden>
              <p class="mb-3">
                Scegli la causale della cancellazione
              </p>
              <vs-row class="m-3">
                <vs-col vs-offset="4" vs-justify="center" vs-align="center" vs-w="4">
                  <!-- <vs-select class="mb-3" v-model="causale_eliminato"> -->
                    <!-- <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in ['Documento Errato','Altro']" /> -->
                  <div v-for="(item, index) in ['Documento Errato','Altro']" :key="index" class="mb-3">
                    <vs-radio v-model="causale_eliminato" vs-name="radio_reason" :vs-value="item">{{ item }}</vs-radio>
                  </div>
                  <!-- </vs-select> -->
                </vs-col>
              </vs-row>
              <vs-row v-if="causale_eliminato == 'Altro'" class="m-3">
                <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                  <vs-input v-model="causale_eliminato_text" name="causale_eliminato_text" />
                </vs-col>
              </vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button @click="eliminaContratto(tr_)" icon-pack="feather" icon="icon-trash-2" type="line" color="danger"> Elimina </vs-button>
              </vs-col>
            </vs-popup>
            <vs-popup :key="Math.random()" class="holamundo text-center" title="Avanza Stato Contratto" :active.sync="popupStato">
              <p class="mb-3">
                Scegliere lo stato a cui portare il Contratto
              </p>
              <vs-row class="m-3">
                <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                  <v-select class="mb-3 w-full" v-model="avanza_stato"
                    :options="avaiableStati"
                    :filterable="false"
                    placeholder="Seleziona stato">
                  </v-select>
                  <!-- <vs-select class="mb-3" v-model="avanza_stato">
                    <vs-select-item v-if="tr_.stato.ordine < 2" :key="1" value="2" text="Consegnato" />
                    <vs-select-item v-if="tr_.stato.ordine < 4" :key="2" value="4" text="Accettato" />
                    <vs-select-item v-if="tr_.stato.ordine < 5" :key="3" value="5" text="Rifiutato" />
                  </vs-select> -->
                </vs-col>
              </vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button @click="commitStato(tr_)" icon-pack="feather" icon="icon-cloud-lightning" type="line" color="success"> Cambia Stato </vs-button>
              </vs-col>
            </vs-popup>
            <signature v-if="popupSig" @close="closeSig" :active_pop="popupSig" :contratto="id_sig" :id_stato="stati.find(e => e.ordine == 8).id" :uff="uffici" :type="type_sig" :data="null" />
            <upload-doc v-if="popupUpl" @close="closeSig" :active_pop="popupUpl" :id_contratto="id_selected" />
          </vs-tr>
        </template>
      </vs-table>
      <vs-sidebar click-not-close position-right parent="body" color="primary" :class="['sidebarx sidebarpage',sidebar_type == 'mail' ? 'sidebar-utenti' : 'sidebar-documento']" spacer v-model="sidebar_active">
        <sidebar-new-contratto @close-me="sidebarClose" @contratto-creato="handleContrattoCreato" v-if="sidebar_type === 'form-contratto'" :key="formkey" :selected="_.cloneDeep(this.selected)"></sidebar-new-contratto>
        <sidebar-mail @mail-inviata="sentMail" @close-me="sidebarClose" v-else-if="sidebar_type === 'mail' && selected" :stato_inviato="inviato.id" :selected="selected" :key="formkey" />
        <SidebarUploadFile @close-me="sidebarClose" @documento-creato="notifyAvanzo({title:'Cambio Stato',text:'Passaggio a Copia Cartacea',color:'warning'})" v-else-if="sidebar_type === 'documento' && id_selected" :selected="id_selected" />
      </vs-sidebar>
  </div>
</template>

<script>
import axios from 'axios'
import ExpandableContratto from './ExpandableContratto.vue'
import SidebarPreventivo from './SidebarPreventivo.vue'
import SidebarNewPreventivo from './SidebarNewPreventivo.vue'
import SidebarNewContratto from './SidebarNewContratto.vue'
import SidebarContratto from './SidebarContratto.vue'
import SearchBar from '../commons/SearchBar.vue'
import Signature from './Signature.vue'
import SidebarUploadFile from './UploadDoc.vue'
import SidebarMail from './SidebarMail.vue'

export default {
    data() {
        return {

            message: '',

            selected: null,
            id_selected: null,
            tr_: { stato: {} },
            id_preventivo: null,
            motivo: null,
            sidebar_type: '',
            sidebar_active: false,
            documenti: [],
            stati: [],
            stato_attesa: null,
            hasNext: false,
            formkey: Math.random(),
            tablekey: Math.random(),
            keyword: "",
            page: 1,
            tot_page: 0,
            elements_per_page: 15,
            popupDelete: false,
            popupStato: false,
            popupSig: false,
            popupUpl: false,
            type_sig: "",
            id_sig: null,
            causale_eliminato: '',
            causale_eliminato_text: '',
            avanza_stato: 0,
            inviato: null,
            uffici: [],

            c_filters: [  {label:'Tutti',icon:'icon-code'},
                          {label:'Aperto',icon:'icon-clock'},
                          {label:'Inviato',icon:'icon-mail'},
                          {label:'Consegnato',icon:'icon-compass'},
                          {label:'Revisionato',icon:'icon-refresh-ccw'},
                          {label:'Accettato',icon:'icon-thumbs-up'},
                          {label:'Rifiutato',icon:'icon-thumbs-down'},
                          {label:'Firmato',icon:'icon-edit-1'},
                          {label:'Copia Cartacea',icon:'icon-paperclip'}  ]
                          // {label:'Cancellato',icon:'icon-trash'}  ]
        }
    },
    components: {
      ExpandableContratto,
      SidebarPreventivo,
      SidebarNewPreventivo,
      SidebarNewContratto,
      SidebarContratto,
      SearchBar,
      Signature,
      SidebarUploadFile,
      SidebarMail,
    },
    beforeMount () {
      this.getDocumenti()
      this.getStati()
      this.getUffici()
    },
    mounted () {
      if (localStorage.utente_nome) {
        this.utente_nome = localStorage.utente_nome
      }
      if (localStorage.utente_id) {
        this.utente_id = localStorage.utente_id
      }
      if (this.$route.params.wanted_id) {
        setTimeout(() => this.openWanted(this.$route.params.wanted_id), 500)
      }
    },

    computed: {
      avaiableStati: {
        get () {
          let x = []
          if (this.tr_ && this.tr_.stato.ordine < 2) x.push({label:'Consegnato',value:2})
          if (this.tr_ && this.tr_.stato.ordine < 4) x.push({label:'Accettato',value:4})
          if (this.tr_ && this.tr_.stato.ordine < 5) x.push({label:'Rifiutato',value:5})
          return x
        },
        // set (v) { if (!v) this.new_form = null }
      },
    },

    methods: {
        onlyUnique(value, index, self) {
          return self.indexOf(value) === index;
        },
        getDocumenti() {
          this.activeLoading = true
          this.$vs.loading({
            type:'radius',
          })
          axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/trova_tutti', {
            pag: this.page,
            option: this.option ? this.option.label : "Tutti",
            keyword: this.keyword,
            take: this.elements_per_page
          },{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          .then(response => {
            if (response.data.length == 0) {  this.documenti = []
                                              this.hasNext = false }
            else {
              response.data.res.forEach( el => {
                let rev = el.stati.filter( s => s.id_stato == 4) //stato revisionato (possibili duplicati)
                let stato_rev = rev.pop()
                if (stato_rev) {
                  el.stati = el.stati.filter( s => {
                    if (!rev.includes(s)) return s
                    else if (s == stato_rev) return s
                  })
                }
              });

              this.documenti = response.data.res
              this.hasNext = this.documenti.length >= this.elements_per_page
              this.tot_page = Math.ceil(response.data.count / this.elements_per_page)
              this.selected = this.selected ? this.documenti.find( a => a.id == this.selected.id) : {}
            }
            this.$vs.loading.close()
          })
          .catch(e => {
            console.log(e)
            this.$vs.loading.close()
          })
        },
        isDisabled(c) {
          if (c.id_creatore == this.utente_id || c.id_responsabile == this.utente_id || this.$acl.check('responsabile')) return false
          else return true
        },
        nextPage() {
          if (this.page < this.tot_page) {
            this.page += 1
            this.getDocumenti()
          }
        },
        prevPage() {
          this.page -= 1
          this.getDocumenti()
        },
        openSidebarContratto(preventivo, index_contratto) {
            this.selected = null
            Object.keys(preventivo.contratto).forEach(e => this.selected[e] = !preventivo.contratto[e] ? "" : preventivo.contratto[e])
            this.selected['preventivo'] = preventivo

            this.selected.index_contratto = index_contratto
            this.formkey = Math.random()
            this.sidebar_type = 'contratto'
            this.sidebar_active = true
        },
        handleModificaContratto(c) {
          this.removeTooltip()
          if (!c.preventivo.voci) {
            this.$vs.notify({
              color: 'error',
              time: 4000,
              title: 'Errore voci',
              text: 'qualche dato mancante, contattare l\'amministratore di sistema'
            })
          } else {
            if (c) {
              c['voci_preventivo'] = c.preventivo.voci
              c['azienda'] = c.preventivo.azienda
              this.selected = c
              this.formkey = Math.random()
              this.sidebar_type = 'form-contratto'
              this.sidebar_active = true
            }
          }
        },
        open_delete(contratto) {
          this.removeTooltip()
          this.tr_ = contratto
          this.popupDelete = true
        },
        open_stato(contratto) {
          this.removeTooltip()
          this.tr_ = contratto
          this.popupStato = true
        },
        open_firma(contratto) {
          this.removeTooltip()
          // this.tr_ = contratto
          this.popupSig = true
          this.id_sig = contratto
          this.type_sig = 'cliente'
        },
        closeSig() {
          this.popupSig = false
          this.popupUpl = false
          this.getDocumenti()
        },
        open_upl(id) {
          this.removeTooltip()
          this.id_selected = id
          this.sidebar_type = 'documento'
          this.sidebar_active = true
        },
        eliminaContratto(contratto) {
          let url = process.env.VUE_APP_BACKEND_API+'/contratto/avanza_stato'
          axios.post(url, {id: contratto['id'], id_stato: this.stati.find(e => e.stato == 'Cancellato').id, causale_eliminato: this.causale_eliminato},{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          .then(response => {
            // console.log(response);
            this.setPreventivo(contratto.id_preventivo)
          })
          this.causale_eliminato = ''
          this.tr_ = { stato: {} }
          this.popupDelete = false
          this.getDocumenti()
        },
        setPreventivo(id_preve) {
          axios.post(process.env.VUE_APP_BACKEND_API+'/preventivo/associa_contratto', {id:id_preve,id_contratto:0},{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          // .then(response => {
          //   console.log(response.data);
          // })

          axios.post(process.env.VUE_APP_BACKEND_API+'/preventivo/remove_stato', {id:id_preve,id_stato:this.stati.find(e => e.stato == 'Accettato').id},{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          // .then(response => {
          //   console.log(response.data);
          // })
        },
        cercaDocumento(k,opt) {
          this.tablekey = Math.random()
          this.keyword = k
          this.option = opt
          this.page = 1
          this.getDocumenti()
        },
        getStati() {
          axios.get(process.env.VUE_APP_BACKEND_API+'/preventivo/elenca_stati',
                    {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                    withCredentials: true,
          }).then(response => {
            this.stati = response.data.map(e => {
                                      e['label'] = `${e['stato']}`
                                      return e
                                    })
            this.stato_attesa = this.stati.find(e => e.label == "Aperto")
                                  })

          .catch(e => console.log(e))
        },
        commitStato(contratto) {
          let url = process.env.VUE_APP_BACKEND_API+'/contratto/avanza_stato'
          axios.post(url, {id: contratto.id, id_stato: this.stati.find(e => e.ordine == this.avanza_stato.value).id},{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          .then(response => {
            // this.$emit('stato-avanzato')
            this.avanza_stato = 0
            this.tr_ = { stato: {} }
            this.popupStato = false
            this.getDocumenti()
          })
        },
        getDocumentiContratto(contratto) {
          axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/documento/trova_tutti_documenti_contratto', {
            id: contratto.id,
          },{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          .then( response => {
            // console.log(response.data);
            const target_documento = response.data ? response.data[0] : null
            if (target_documento) { // double check
              axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/documento/download', {
                id: target_documento.id,
                nuovo_nome: target_documento.nuovo_nome,
                nome: target_documento.nome,
              },{
                headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
                responseType: 'blob'
              })
              .then(
                response => {
                const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
                const link = document.createElement('a');
                link.href = url
                this.$vs.loading.close()
                link.setAttribute('download', response.headers['x-file-name']);
                document.body.appendChild(link);
                link.click();
                this.$vs.notify({
                  color: 'success',
                  time: 4000,
                  title: 'File in download',
                  text: 'controlla la finestra di download'
              })
              }
              ).catch(e => {
                this.$vs.notify({
                  color: 'warning',
                  time: 4000,
                  title: 'Errore',
                  text: 'riprovare o/e contattare supporto'
                })
                this.$vs.loading.close()
              })
            } else {
              this.$vs.notify({
                color: 'warning',
                time: 4000,
                title: 'Errore File',
                text: 'file nissing'
              })
            }
          })
        },
        evaluateContrattoCartaceo(contratto) {
          const stati = contratto.stati
          let hasCopiaCartacea = false
          stati.forEach( s => {
            if (s.stato.ordine == 9) {
              hasCopiaCartacea = true
            }
          })
          return hasCopiaCartacea
        },
        async generatePDF(contratto, ev) {
          this.activeLoading = true
          this.$vs.loading({
            type:'radius',
          })

          if (this.evaluateContrattoCartaceo(contratto)) { // check if stati has "copia cartacea"
          // if (contratto.stato.ordine == 9) { // old logic only when stato was "copia cartacea"
            // fetch local documenti
            this.getDocumentiContratto(contratto)
            // download local fetched document
          } else if (contratto.envelope_id && contratto.document_id) { // If contratto has envelope_id so retrieve this from docusign
          // if (contratto.stato.ordine == 8 && contratto.envelope_id && contratto.document_id) {
            axios.post(process.env.VUE_APP_BACKEND_API+'/docusign/getSingleDocument', {
              envelope_id: contratto.envelope_id,
              document_id: 1, // always ONE document only for each envelope
              filename: contratto.document_name,
              status_doc_firmato: contratto.status_doc_firmato
            },{
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
              responseType: 'blob'
            })
            .then( response => {
              // console.log(response)
              const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
              const link = document.createElement('a');
              link.href = url
              this.$vs.loading.close()
              link.setAttribute('download', response.headers['x-file-name']);
              document.body.appendChild(link);
              link.click();
              if (!contratto.status_doc_firmato) {
                this.$vs.notify({
                  color: 'success',
                  time: 4000,
                  title: 'Documento N°'+contratto.numero+' firmato',
                  text: 'il Cliente ha accolto la richiesta di firma, è stato aggiornato lo stato.'
                })
                this.getDocumenti()
              }
            }
            ).catch(e => {
              this.$vs.notify({
                color: 'warning',
                time: 4000,
                title: 'Errore Acquisizione Documento',
                text: 'riscontrati problemi con DocuSign, riprovare'
              })
              console.log(e)
              this.$vs.loading.close()
            })
          } else {
// else below code
            let p_to_print = _.cloneDeep(contratto)
            // console.log(contratto,'   :contratto <==> p_to_print:   ',p_to_print);
            p_to_print = await this.$tariffe.generatePDFcontratto(p_to_print)
            let uff = this.uffici.find( el => el.codice == p_to_print['codice_ufficio'])
            p_to_print['codice_ufficio'] = uff ? [uff.descrizione,' (',uff.codice,')'].join('') : ''

            axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/generate_file', {
              templates: p_to_print.templates,
              object: p_to_print,
              contratto: true,
            },{
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
              responseType: 'blob'
            })
            .then( response => {
              const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
              const link = document.createElement('a');
              link.href = url
              this.$vs.loading.close()
              link.setAttribute('download', response.headers['x-file-name']);
              document.body.appendChild(link);
              link.click();
            }
            ).catch(e => {
              this.$vs.notify({
                color: 'warning',
                time: 4000,
                title: 'Errore Template',
                text: 'riscontrati problemi con uno dei template di stampa'
              })
              // console.log(e)
              this.$vs.loading.close()
            })
          }
          if (ev) ev.stopPropagation()
        },
        getNumero(n,date) {
          let d_n = new Date(date).getYear() + 1900
          return [n,'/',d_n].join('')
        },
        openWanted(id) {
          axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/get', {
            id: id,
          },{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          }).then(response => {
            if (response.data) {
              this.handleModificaContratto(response.data)
              //   let wanted = this.documenti.find( c => c.id == this.$route.params.wanted_id )
            }
          }).catch(e => { console.log(e) })
        },
        sidebarClose() {
          this.selected = null
          this.sidebar_active = false
          this.id_selected = null
          this.sidebar_type = ''
        },
        handleContrattoCreato(message,id,firma) {
          this.sidebar_active = false
          this.formkey = Math.random()
          if (message === 'OK') {
            this.page = 1
            this.keyword = ""
            this.getDocumenti()
          }
          // else if (message === 'Firma' && !firma) {
          //   this.popupSig = true
          //   this.id_sig = id
          //   this.type_sig = 'consulente'
          // }
          else {
            this.getDocumenti()
          }
        },
        openPrev(id) {
          this.removeTooltip()
          this.$router.push({ name: 'documenti-preventivi', params: { wanted_id: id } })
        },
        inviaDoc(tr,ev) {
          this.formkey = Math.random()
          this.sidebar_type = 'mail'
          this.sidebar_active = true
          this.inviato = this.stati.find(e => e.ordine == 1)
          this.selected = tr
          if (ev) {
            ev.stopPropagation()
          }
        },
        sentMail() {
          this.sidebar_active = false
          this.selected = null
          this.$vs.notify({
            color: 'success',
            time: 4000,
            title: 'Mail inviata',
            text: 'il messaggio mail è stato spedito'
          })
          this.getDocumenti()
        },
        notifyAvanzo(obj) {
          axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/avanza_stato', {id:this.id_selected,id_stato:this.stati.find(e => e.stato == 'Copia Cartacea').id},{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          }).then(response => {
            this.$vs.notify({
              color: obj.color,
              time: 4000,
              title: obj.title,
              text: obj.text
            })
            this.sidebarClose()
          })
        },
        getUffici() {
          axios.get(process.env.VUE_APP_BACKEND_API+'/azienda/get_uffici',
                    {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                    withCredentials: true,
          }).then(response => {
                        this.uffici = response.data
          }).catch(e => console.log(e))
        },
        removeTooltip() {
          let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
          if (elements.length) {
            elements[0].remove();
          }
        }
    },
}
</script>
